import { createCardPRVerbose } from '@lc/interface/card/pr/factory';
// import { PRMeta } from '@lc/card/meta/ss/PRMeta';
import { PR } from '@lc/interface/card/pr/types';

export const getPRVerbose = (PRMeta: PR[]) => [
	createCardPRVerbose(PRMeta[0]), // 58
	createCardPRVerbose(PRMeta[1]), // 59
	createCardPRVerbose(PRMeta[2]), // 60
	createCardPRVerbose(PRMeta[3]), // 61
	createCardPRVerbose(PRMeta[4]), // 62
	createCardPRVerbose(PRMeta[5]), // 63
	createCardPRVerbose(PRMeta[6]), // 64
	createCardPRVerbose(PRMeta[7]), // 65
	createCardPRVerbose(PRMeta[8]), // 66
	createCardPRVerbose(PRMeta[9]), // 67
	createCardPRVerbose(PRMeta[10]), // 68
	createCardPRVerbose(PRMeta[11]), // 69
];
